/* eslint-disable no-nested-ternary */
import { memo } from 'react';
import {
  Stack,
  TextField as MuiTextField,
  OutlinedTextFieldProps,
  Typography,
  SxProps,
  Theme,
  InputBaseComponentProps,
} from '@mui/material';

interface IStackTextFieldProps extends Partial<OutlinedTextFieldProps> {
  label?: string;
  essential: boolean;
  labelWidth?: number | string;
  width?: number | string;
  marginBottom?: string;
  text?: string | Date | null;
  directionType?: string;
  stackSx?: SxProps;
  labelSx?: SxProps;
  maxLength?: number;
  alignItems?: string;
  inputPropsSx?: InputBaseComponentProps;
}

function StackTextField({
  label,
  essential,
  labelWidth = '100px',
  width,
  marginBottom = '16px',
  text,
  directionType = 'default',
  stackSx = {},
  labelSx = {},
  inputPropsSx = {},
  alignItems = 'center',
  ...others
}: IStackTextFieldProps) {
  const labelStyle: SxProps<Theme> = {
    color: 'text.primary',
    minWidth: labelWidth,
    maxWidth: labelWidth,
  };
  const labelStyle2 = {
    maxWidth: { xs: '100%', md: labelWidth },
    width: { xs: '100%', md: labelWidth },
  };
  const dType = directionType === 'default';
  let labelResult = {
    ...labelStyle,
    ...labelSx,
  };
  if (!dType) {
    labelResult = {
      ...labelStyle,
      ...labelStyle2,
      ...labelSx,
    };
  }
  return (
    <Stack
      sx={{ marginBottom, ...stackSx }}
      spacing="8px"
      direction={dType ? 'row' : { xs: 'column', md: 'row' }}
      alignItems={alignItems}
    >
      {label && (
        <Typography sx={labelResult} noWrap>
          {label}
          {essential && <em style={{ color: 'red' }}> *</em>}
        </Typography>
      )}

      <MuiTextField
        {...others}
        inputProps={{ maxLength: others?.maxLength, ...inputPropsSx }}
        value={text}
        autoComplete="off"
        sx={theme => ({
          width: width || '100%',
          height: others.rows === undefined ? 40 : 'auto',
          border: 'none',
          borderRadius: '4px',
          '& .MuiInputBase-root': {
            border: others.error
              ? `1px solid ${theme.palette.error.main}`
              : `1px solid ${theme.palette.mind.custom.textBorder}`,
            ':hover': {
              border: others?.disabled
                ? '0px solid'
                : others.error
                  ? `1px solid ${theme.palette.error.main}`
                  : `1px solid ${theme.palette.text.primary}`,
            },
            '&.Mui-focused': {
              border: others.error
                ? `1px solid ${theme.palette.error.main}`
                : `2px solid ${theme.palette.primary.main}`,
            },
          },
          '& .MuiInputBase-input': {
            color: theme.palette.text.primary,
            padding: others?.rows ? '0px' : '10px 16px',
            lineHeight: '20px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
            borderColor: 'rgba(0, 0, 0, 0.23)',
          },
          '& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled': {
            textFillColor: 'rgba(0, 0, 0, 0.38)',
            backgroundColor: '#E0E0E0',
            ':hover': {
              border: '0px',
            },
          },
        })}
      />
    </Stack>
  );
}

export default memo(StackTextField);
